
import { Exhibit } from '../types';

export const ancientExhibits: Exhibit[] = [
  {
    id: 3,
    numberCode: "201",
    titleEn: "Tutankhamun's Death Mask",
    titleHe: "מסכת המוות של תות אנך אמון",
    descriptionEn: "The iconic golden funeral mask of the ancient Egyptian Pharaoh Tutankhamun, created around 1323 BCE.",
    descriptionHe: "מסכת הקבורה המוזהבת האייקונית של פרעה מצרי עתיק תות אנך אמון, שנוצרה בסביבות 1323 לפני הספירה.",
    image: "https://images.unsplash.com/photo-1608372166080-55ae68e0c081",
    hasAudio: true,
    hasVideo: true,
    location: {
      floor: 1,
      room: "Egypt Hall",
      x: 180,
      y: 350
    }
  },
  {
    id: 4,
    numberCode: "202",
    titleEn: "Rosetta Stone",
    titleHe: "אבן רוזטה",
    descriptionEn: "A granodiorite stele discovered in 1799, inscribed with three versions of a decree issued in Memphis, Egypt in 196 BCE.",
    descriptionHe: "אסטלה גרנודיוריט שהתגלתה בשנת 1799, חרוטה עם שלוש גרסאות של צו שהוצא בממפיס, מצרים בשנת 196 לפני הספירה.",
    image: "https://images.unsplash.com/photo-1603721123843-c9347e5a4c76",
    hasAudio: true,
    hasVideo: false,
    location: {
      floor: 1,
      room: "Egypt Hall",
      x: 300,
      y: 300
    }
  },
  {
    id: 6,
    numberCode: "203",
    titleEn: "Ancient Greek Vase",
    titleHe: "כד יווני עתיק",
    descriptionEn: "A remarkably preserved Greek ceramic vessel from the 5th century BCE.",
    descriptionHe: "כלי קרמיקה יווני משומר היטב מהמאה החמישית לפני הספירה.",
    image: "https://images.unsplash.com/photo-1594736797933-d0501ba2fe65",
    hasAudio: true,
    hasVideo: false,
    location: {
      floor: 1,
      room: "Greece Hall",
      x: 220,
      y: 420
    }
  },
  {
    id: 7,
    numberCode: "204",
    titleEn: "Roman Mosaic",
    titleHe: "פסיפס רומי",
    descriptionEn: "An intricate floor mosaic depicting scenes from Roman mythology.",
    descriptionHe: "פסיפס רצפה מורכב המתאר סצנות מהמיתולוגיה הרומית.",
    image: "https://images.unsplash.com/photo-1669051582403-8c1544e08a6d",
    hasAudio: true,
    hasVideo: false,
    location: {
      floor: 1,
      room: "Rome Hall",
      x: 350,
      y: 450
    }
  }
];
